const fontSizes = require('./constants/fontSizes')
const getDeviceType = require('./utils').getDeviceType

function getBrowserFontSizeSetting(store) {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (store && typeof store.dispatch === 'function') {
      store.dispatch('updateBrowserFontSizeSetting', 'medium')
    }
    return 'medium'
  }

  const rootFontSize = window.getComputedStyle(document.documentElement).fontSize
  const size = parseFloat(rootFontSize)
  let setting = 'medium'
  if (size < 11.5) setting = 'very-small'
  else if (size < 15.5) setting = 'small'
  else if (size < 18.5) setting = 'medium'
  else if (size < 21) setting = 'large'
  else setting = 'very-large'

  if (store && typeof store.dispatch === 'function') {
    store.dispatch('updateBrowserFontSizeSetting', setting)
  }
  return setting
}

function applyFontSizeMultiplier(fontSize, vueInstance) {
  const adjustmentMap = {
    'very-small': 0.8,
    'small': 0.9,
    'medium': 1,
    'large': 1.2,
    'very-large': 1.5
  }
  const browserSetting = (vueInstance && vueInstance.$store && vueInstance.$store.getters && vueInstance.$store.getters.getBrowserFontSizeSetting)
    ? vueInstance.$store.getters.getBrowserFontSizeSetting
    : 'medium'
  const multiplier = adjustmentMap[browserSetting] || 1
  if (typeof fontSize === 'string') {
    const match = fontSize.match(/^([0-9.]+)([a-z%]*)$/i)
    if (match) {
      const num = parseFloat(match[1])
      const unit = match[2] || ''
      return (num * multiplier) + unit
    }
    return fontSize
  } else if (typeof fontSize === 'number') {
    return fontSize * multiplier
  }
  return fontSize
}

function getFontSize(field, options) {
  options = options || {}
  const forChatInterface = typeof options.forChatInterface === 'undefined' ? true : options.forChatInterface
  const forIntentResponse = typeof options.forIntentResponse === 'undefined' ? true : options.forIntentResponse
  let type = 'default'

  if (forChatInterface) {
    type = this && this.$store && this.$store.getters && this.$store.getters.getFontSizeType && this.$store.getters.isFontSizeChatInterfaceOverrideEnabled
      ? this.$store.getters.getFontSizeType
      : 'default'
  }
  else if (forIntentResponse) {
    type = this && this.$store && this.$store.getters && this.$store.getters.getFontSizeType && this.$store.getters.isFontSizeWFContentOverrideEnabled
      ? this.$store.getters.getFontSizeType
      : 'default'
  }
  else {
    type = this.$store.getters.getFontSizeType
  }
  if (!fontSizes[field]) {
    return applyFontSizeMultiplier('16px', this)
  }
  if (fontSizes[field][type]) {
    // If full screen, increase font size by 2px
    let fontSize = fontSizes[field][type]
    if (isFullScreen.call(this) && typeof fontSize === 'string' && fontSize.endsWith('px')) {
      const num = parseInt(fontSize, 10)
      fontSize = (num + 2) + 'px'
    }
    return applyFontSizeMultiplier(fontSize, this)
  }
  return applyFontSizeMultiplier('16px', this)
}

function isFullScreen() {
    return getDeviceType() !== 'mobile' && this.$store.state.isChatWidgetFullScreen
}

function getLineHeightForFontSize(fontSize) {
  const size = typeof fontSize === 'number'
    ? fontSize
    : (typeof fontSize === 'string' ? parseFloat(fontSize) : NaN)

  if (!Number.isFinite(size)) {
    return 'normal'
  }

  const map = {
    9: 12,
    10: 14,
    11: 15,
    12: 16,
    13: 18,
    14: 20,
    15: 21,
    16: 24,
    17: 25,
    18: 26,
    19: 28,
    20: 28,
    21: 30,
    22: 32,
    23: 32,
    24: 34
  }
  const exact = Number.isInteger(size) ? map[size] : undefined
  const lineHeight = typeof exact !== 'undefined' ? exact : Math.round(size * 1.4)
  return lineHeight + 'px'
}

module.exports = {
  getFontSize,
  getBrowserFontSizeSetting,
  getLineHeightForFontSize
}
